import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { SplitCountInputProps } from './interface'

const options = [
  {
    label: '整体拍',
    value: true
  },
  {
    label: '拆分拍',
    value: false
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: SplitCountInputProps) => {
  const handleSelectChange = (wholeSale: boolean) => {
    onChange?.({ ...value, wholeSale, splitCount: wholeSale ? 1 : 2 })
  }

  const handleInputChange = (splitCount: string | number | null) => {
    onChange?.({
      ...value,
      splitCount: isNil(splitCount) ? 1 : Number(splitCount)
    })
  }

  return (
    <Space.Compact>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        style={{ width: 160 }}
        value={value.wholeSale}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={value.wholeSale !== false || disabled}
        min={value.wholeSale ? 1 : 2}
        value={value.splitCount}
        onChange={handleInputChange}
      />
      <Space.Addon>份</Space.Addon>
    </Space.Compact>
  )
}

export const SplitCountInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
